import api from '@/api';

export default {
  // 바로가기 가져오기
  getShortcutInfoList(webpartId: string) {
    return api.get({
      url: `/Webpart/WebpartShortcut/api/getList?webpartId=${webpartId}`,
    });
  },
};
